import { render, staticRenderFns } from "./ShowTask.vue?vue&type=template&id=b8f80d42&scoped=true"
import script from "./ShowTask.vue?vue&type=script&lang=js"
export * from "./ShowTask.vue?vue&type=script&lang=js"
import style0 from "./ShowTask.vue?vue&type=style&index=0&id=b8f80d42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f80d42",
  null
  
)

export default component.exports